document.addEventListener('DOMContentLoaded', async function() {
    const collectionContainer = document.querySelector('.collection-container');
    let abortController;
    const productGridContainer = document.querySelector('.collection-container #ProductGridContainer');
    const urlParams = new URLSearchParams(window.location.search);
    const querySearch = urlParams.get('q') ? (urlParams.get('q')) : '';
    const productsPerPage = 24;
    const inlineBanner = true;
    const pageNumber = urlParams.get('page') ? parseInt(urlParams.get('page')) : 1;
    const shopUrl = Shopify.shop;
    let pageLoad = false;

    const baseUrl = 'https://cr8s7s.a.searchspring.io/api/search/search.json';
    const queryParams = {
        ajaxCatalog: 'v3',
        resultsFormat: 'native',
        siteId: 'cr8s7s',
        domain: window.location.origin + window.location.pathname,
        bgfilter: {
            search_query: querySearch,
            ss_available: '1',
            ss_has_tags: '1'
        },
        filter: {},
        type: 'filter',
        disableInlineBanners: inlineBanner,
        q: querySearch,
        page: pageNumber,
        userId: 'db8c2ca1-e581-4f07-9c2f-f8ce16fd9b66',
        sessionId: '164b6ef2-b723-43bb-ab2e-d0ba28622e46',
        pageLoadId: '79ac628a-ef44-4959-9d1c-e70702a24739'
    };

    const color_settings = window[`settings`];
    const customColorsArray = color_settings.color_swatches.split(',').map(color => {
        const [key, value] = color.split(':').map(part => part.trim());
        return { key: key.toLowerCase(), value: value };
    });
    const keyArray = customColorsArray.map((color) => color.key);
    const valArray = customColorsArray.map((color) => color.value);
  
    const checkAndValidateFilters = async(querySearch) => {
        let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
        if (storedFilters.hasOwnProperty('collection_handle')) {
            delete storedFilters.collection_handle;
            storedFilters.search_query = querySearch;
            sessionStorage.setItem('natoriFilters', JSON.stringify(storedFilters));
            sessionStorage.removeItem('natoriSort');
        }
        if (storedFilters.hasOwnProperty('search_query')) {
            if (storedFilters.search_query !== querySearch) {
                sessionStorage.removeItem('natoriFilters');
                sessionStorage.removeItem('natoriSort');
            }
        }
    };

    // const formatPrice = (price) => {
    //     const number = parseFloat(price);
    //     return number % 1 === 0 ? number.toFixed(0) : number.toFixed(2);
    // };

    const formatPrice = (price) => {
        const number = parseFloat(price);
        const currency = window.theme.settings.money_with_currency_format.replace(/{{.*?}}/g, '');
        
        let locale;
         switch (currency) {
            case '€': 
                locale = 'de-DE';
                break;
            case 'CHF':
                locale = 'de-CH';
                break;
            case 'R$':
                locale = 'pt-BR';
                break;
            case '¥':
                locale = 'ja-JP';
                break;
            case '$':
            default:
                locale = 'en-US';
                break;
        }
    
        return number.toLocaleString(locale, { 
            minimumFractionDigits: 0, 
            maximumFractionDigits: 2 
        });
    };

    async function FacetsToggle() {
        const container = document.getElementById("Facet-Drawer");
        const button = document.getElementById("Facets-Toggle");
    
        if (button) {
            button.addEventListener("click", function(e) {
                e.preventDefault();
                document.getElementsByTagName("body")[0].classList.toggle("open-cc");
                container.classList.toggle("active");
            });
        }
    }

    function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(this, args), delay);
        };
    }

    const fetchColorValue = async (key) => {
        let colorValue = key.toLowerCase().trim();
        const customColorIndex = keyArray.indexOf(colorValue);
        if (customColorIndex > -1) {
            colorValue = valArray[customColorIndex];
        }
    
        let bgValue = false;
        if (colorValue.includes(".")) {
            bgValue = colorValue;
            colorValue = "var(--bg-body)";
        }
    
        const shopDomain = window.location.hostname;
        const bgImageUrl = bgValue? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');`: "--option-color-image: false";
        const style = `--bg-color: ${colorValue}; ${bgImageUrl}`;
        return style;
    };
    const waitForYotpo = async () => {
        return new Promise(resolve => {
            if (yotpo?.userSettings) {
                resolve();
            }
        });
    };
    const sendYotpoRequest = async (prodId,prodUrl) => {
        if (!yotpo?.userSettings) {
            await waitForYotpo();
        }
        const yotpoKey = yotpo.appKey;
        const yotpoVersion = yotpo.userSettings.version;
        const data = {
            methods: [
                {
                    method: "bottomline",
                    params: {
                        pid: prodId,
                        link: prodUrl,
                        skip_average_score: true,
                        widget_product_id: prodId 
                    }
                }
            ],
            app_key: yotpoKey,
            is_mobile: false,
            widget_version: yotpoVersion
        };
    
        return fetch(`https://staticw2.yotpo.com/batch/app_key/${yotpoKey}/domain_key/${prodId}/widget/bottomline`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error('Error:', error);
            throw error;
        });
    };
  
    const productReviews = async () => {
        const productCards = document.querySelectorAll('product-card.product-card');
        for (const productCard of productCards) {
            const productBottomLine = productCard.querySelector('.product-card-info .productInfoRight .plpRatings .yotpo.bottomLine');
            const prodUrl = productCard.querySelector('.product-featured-image-link')?.href;
            if (productBottomLine && prodUrl) {
                const prodId = productBottomLine.getAttribute('data-product-id');
                try {
                    const yotpoWidget = await sendYotpoRequest(prodId,prodUrl);
                    if (yotpoWidget && yotpoWidget[0] && yotpoWidget[0].result) {
                        const yotpoReviews = yotpoWidget[0].result;
                        productBottomLine.innerHTML = yotpoReviews;
                    }
                } catch (error) {
                    console.error('Failed to load Yotpo reviews for product ID:', prodId, error);
                }
            }
        }
        await updateReviewStars();
    };

    const updateColorValue = async () => {
        const colorLabels = document.querySelectorAll('.thb-filter ul.list-color label.facet-checkbox');
        
        for (const label of colorLabels) {
            try {
                const colorKey = label.dataset.key;
                const colorValue = await fetchColorValue(colorKey);
    
                if (colorValue) {
                    const styles = colorValue.split(';').filter(Boolean);
    
                    styles.forEach(style => {
                        const [property, value] = style.split(':').map(s => s.trim());
                        if (property && value) {
                            label.style.setProperty(property, value);
                        }
                    });
                } else {
                    console.warn(`No color value returned for key: ${colorKey}`);
                }
            } catch (error) {
                console.error(`Failed to fetch or apply color value for key: ${label.dataset.key}`, error);
            }
        }
    };

    const getStep = (minPrice, maxPrice) => {
        const divisors = [10, 7, 5, 3, 2, 1];
        let step = 1;
    
        for (const divisor of divisors) {
            if (minPrice % divisor === 0 && maxPrice % divisor === 0) {
                return divisor;
            }
        }
    
        for (const divisor of divisors) {
            if (maxPrice % divisor === 0) {
                return divisor;
            }
        }
    
        return step;
    };

    await checkAndValidateFilters(querySearch);

    const buildQueryString = (params) => {
        const parts = [];
    
        const processKey = (key, value) => {
            if (Array.isArray(value)) {
                return value.map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&');
            } else if (typeof value === 'object' && value !== null) {
                return Object.keys(value)
                    .map(subKey => processKey(`${key}.${subKey}`, value[subKey]))
                    .join('&');
            } else {
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }
        };
    
        Object.keys(params).forEach(key => {
            if (typeof params[key] === 'object' && params[key] !== null) {
                parts.push(processKey(key, params[key]));
            } else {
                parts.push(processKey(key, params[key]));
            }
        });
    
        return parts.join('&');
    };



    const queryString = buildQueryString(queryParams);
    const url = `${baseUrl}?${queryString}`;

    // fetch(url)
    //     .then(response => {
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok ' + response.statusText);
    //         }
    //         return response.json();
    //     })
    //     .then(data => {
    //         console.log('Success:', data);
    //         createProductGrid(data.results, data.merchandising.content.inline, data.pagination);
    //         createFilters(data.facets);
    //         createMobFilters(data.facets);
    //         createSortingOptions(data.sorting); // Create sorting options
    //     })
    //     .catch(error => {
    //         console.error('There was a problem with the fetch operation:', error);
    //     });

    async function createProductGrid(products, inlineContent, paginationData) {
        const productGrid = document.getElementById('product-grid');
        productGrid.innerHTML = '';
        const productsPerPage = paginationData.perPage;
        const currentPage = paginationData.currentPage;
        const totalResults = paginationData.totalResults;
        const totalProds = totalResults > 1 ? `${totalResults} products` : `${totalResults} product`;
        
        const countLabels = document.querySelectorAll('.facets-mobile-container .thb-filter-count span.facets__label, facetfiltersformmobile .side-panel-inner .thb-filter-count span.facets__label');
        if (countLabels) {
          countLabels.forEach(label => {
            label.textContent = totalProds;
          });
        }else{
            const countLabelsContainer = document.querySelectorAll('.facets-mobile-container .thb-filter-count, facetfiltersformmobile .side-panel-inner .thb-filter-count');
            countLabelsContainer.forEach(label => {
                const countLabel = document.createElement('span');
                countLabel.classList.add('facets__label');
                countLabel.textContent = totalProds;
                label.appendChild(countLabel);
            });
        }

        let inlineIndex = -1;
        let inlineInserted = false;
        let customLabel = false;
        // let customSwatch;
        const defaultImageUrl = `https://${shopUrl}/cdn/shop/t/1/assets/natoriplaceholder.png`;

        if (inlineContent && inlineContent.length > 0) {
            inlineIndex = inlineContent[0].config.position.index;
        }

        products.forEach((product, index) => {
            const prodVariant = parseVariant(product.variants);
            const firstVariant = prodVariant[0];
            let priceContainer = `<ins><span class="amount">$${formatPrice(product.price)}</span></ins>`;
            let comparePriceContainer = '';
            if(firstVariant){
                const comparePrice = parseFloat(firstVariant.compare_at_price);
                const sellPrice = parseFloat(firstVariant.price);
                if(comparePrice>sellPrice){
                    priceContainer =`<ins><span class="amount">$${formatPrice(sellPrice)}</span></ins>`;
                    comparePriceContainer =`<del><span class="amount">$${formatPrice(comparePrice)}</span></del>`;
                }
            }
            let prodImage = product.thumbnailImageUrl ? product.thumbnailImageUrl: defaultImageUrl;
            const productElement = document.createElement('li');
            productElement.className = 'column';
            const productHTML = `
                <product-card class="product-card text-center hide-price" data-source-file="search-fetch">
                    <figure class="product-featured-image spin_overlay">
                        <a href="${product.url}" title="${product.name}" class="product-featured-image-link aspect-ratio aspect-ratio--adapt" style="--padding-bottom: 150%;">
                            <img class="product-primary-image lazyautosizes" src="${prodImage}" alt="${product.name}" style="width:100%;height:100%;"/>
                        </a>
                    </figure>
                    <div class="product-card-info">
                        <div class="productInfosection">
                            <div class="productInfoleft">
                                <div class="product-card-vendor">${product.vendor}</div>
                                <a href="${product.url}" title="${product.name}" class="product-card-title">${product.name}</a>
                            </div>
                            <div class="productInfoRight">
                                <div class="plpRatings">
                                  <div class="yotpo bottomLine" data-product-id="${product.uid}"></div>
                                </div>
                                <span class="price">${comparePriceContainer}${priceContainer}</span>
                            </div>
                        </div>
                        <div class="product-card-swatch" data-product-id="${product.uid}" data-product-name="${product.name}" data-style-no="${product.mfield_custom_merch_style_number}">
                            <div class="product-card-swatches no-js-hidden" id="swatch_section_${product.uid}"></div>
                        </div>
                    </div>
                </product-card>
            `;
            let customSwatch = '';
            productElement.innerHTML = productHTML;
            if (prodVariant && prodVariant.length > 0) {
                const customProdSwatchData = {
                    featured_image_id: prodVariant[0].id,
                    custom_handle: product.url
                };
            
                const customProdSwatch = `window.settings_${product.uid} = ${JSON.stringify(customProdSwatchData)}`;
            
                const customProdSwatchScript = document.createElement('script');
                customProdSwatchScript.textContent = customProdSwatch;
            
                const productSwatch = productElement.querySelector('.product-card .product-card-swatch');
                const productSwatchDirectory = productElement.querySelector('.product-card .product-card-info');
            
                if (productSwatch && productSwatchDirectory) {
                    productSwatch.insertAdjacentElement('afterend', customProdSwatchScript);
                } else {
                    console.error('productSwatch or productSwatchDirectory not found');
                }
            } else {
                console.error('No variants found for product');
            }
            const saleLabel = saleBadge(prodVariant);
            if(saleLabel != null && saleLabel != 'Sale'){
              customLabel = true;
              const featureImage = productElement.querySelector('figure.product-featured-image');
              const featureTag = featureImage.querySelector('a.product-featured-image-link.aspect-ratio');

               const saleLabelElement = document.createElement('span');
               saleLabelElement.classList = "badge top left";
               if (saleLabel == 'Sale'){
                  saleLabelElement.classList.add("onsale");  
               }else{
                  saleLabelElement.classList.add("out-of-stock"); 
               }
               saleLabelElement.innerHTML = saleLabel;
              featureImage.insertBefore(saleLabelElement, featureTag);
            }

            if(product.mfield_custom_product_label){
              const customMetaLabel = String(product.mfield_custom_product_label);
              const featureImage = productElement.querySelector('figure.product-featured-image');
              const featureTag = featureImage.querySelector('a.product-featured-image-link.aspect-ratio');

               const customLabelElement = document.createElement('span');
               if (customLabel){
                  customLabelElement.classList = "badge top right";
               }else{
                  customLabelElement.classList = "badge top left";
               }
               customLabelElement.innerHTML = customMetaLabel;
                featureImage.insertBefore(customLabelElement, featureTag);
            }

            if (!inlineInserted && inlineIndex >= 0 && inlineIndex < productsPerPage * currentPage) {
                const inlinePage = Math.ceil(inlineIndex / productsPerPage);
                const positionOnPage = inlineIndex % productsPerPage;

                if (currentPage === inlinePage && index === positionOnPage) {
                    const inlineElement = createInlineContentElement(inlineContent[0]);
                    if(inlineElement){
                      productGrid.appendChild(inlineElement);
                      inlineInserted = true;
                    }
                }
            }
            productGrid.appendChild(productElement);
        });

        if (!inlineInserted && inlineIndex >= productsPerPage * currentPage - productsPerPage && inlineIndex < productsPerPage * currentPage) {
            const inlineElement = createInlineContentElement(inlineContent[0]);
          if(inlineElement){
            productGrid.appendChild(inlineElement);
          }
        }
        await createPagination(paginationData);
        // await updateReviewStars();
    }

    const parseVariant = (rowVariant) => {
        const stringifiedArray = rowVariant;
        const correctedString = stringifiedArray.replace(/&quot;/g, '"');
        const jsonObjectArray = JSON.parse(correctedString);
        return jsonObjectArray;
    };

    const saleBadge = (prodVariant) => {
        if (!Array.isArray(prodVariant) || prodVariant.length === 0) {
            return null;
        }
        const totalInventory = prodVariant.reduce((total, variant) => {
            return total + (variant.inventory_quantity || 0);
        }, 0);

        if (totalInventory < 1) {
            return `Out of Stock`;
        }
    
        const firstVariant = prodVariant[0];
        const firstVariantComparePrice = parseFloat(firstVariant.compare_at_price) || null;
        const firstVariantPrice = parseFloat(firstVariant.price) || null;
    
        if (firstVariantComparePrice && firstVariantPrice && firstVariantComparePrice > firstVariantPrice) {
            return `Sale`;
        }
    
        return null;
    };
  
    async function createInlineContentElement(inlineContent) {
       try {
        const inlineElement = document.createElement('li');
        inlineElement.className = 'column';
        const inlineHTML = `
            <product-card class="product-card text-center">
                <figure class="product-featured-image spin_overlay">
                    <a href="${inlineContent.value.match(/data-target-url="([^"]+)"/)[1]}" title="${inlineContent.value.match(/data-target-title="([^"]+)"/)[1]}" class="product-featured-image-link aspect-ratio aspect-ratio--adapt" style="--padding-bottom: 150%;">
                        <img class="product-primary-image lazyautosizes" src="${inlineContent.value.match(/data-image-url="([^"]+)"/)[1]}" alt="${inlineContent.value.match(/data-target-title="([^"]+)"/)[1]}" style="width: 100%;" />
                    </a>
                </figure>
            </product-card>
        `;
        inlineElement.innerHTML = inlineHTML;
        return inlineElement;
       } catch (error) {
          console.error('Error creating inline content element:', error);
          return null;
      }
    }

    async function createPagination(paginationData) {
        const { currentPage, totalPages, nextPage, previousPage } = paginationData;
        const paginationContainer = document.querySelector('.pagination');
        paginationContainer.innerHTML = '';
        const urlParams = new URLSearchParams(window.location.search);
        const querySearch = urlParams.get('q') ? `q=${urlParams.get('q')}` : '';
    
        const paginationHtml = document.createElement('div');
        paginationHtml.className = 'page-numbers nav-links';
    
        if (previousPage > 0) {
            const prevButton = document.createElement('span');
            prevButton.className = 'prev';
            prevButton.innerHTML = `<a href="${previousPage === 1 ? window.location.pathname + (querySearch ? '?' + querySearch : '') : '?page=' + previousPage + (querySearch ? '&' + querySearch : '')}" title="Previous">←</a>`;
            paginationHtml.appendChild(prevButton);
        }
    
        let startPage, endPage;
        if (totalPages <= 10) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 4) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage > totalPages - 4) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }
    
        if (startPage > 1) {
            paginationHtml.innerHTML += `<span class="page"><a href="?${querySearch}" title="Page 1">1</a></span>`;
            if (startPage > 2) {
                paginationHtml.innerHTML += `<span class="deco">...</span>`;
            }
        }
    
        for (let i = startPage; i <= endPage; i++) {
            const pageSpan = document.createElement('span');
            pageSpan.className = 'page';
            if (i === currentPage) {
                pageSpan.classList.add('current');
                pageSpan.textContent = i;
            } else {
                pageSpan.innerHTML = `<a href="${i === 1 ? window.location.pathname + (querySearch ? '?' + querySearch : '') : '?page=' + i + (querySearch ? '&' + querySearch : '')}" title="Page ${i}">${i}</a>`;
            }
            paginationHtml.appendChild(pageSpan);
        }
    
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                paginationHtml.innerHTML += `<span class="deco">...</span>`;
            }
            paginationHtml.innerHTML += `<span class="page"><a href="?page=${totalPages}${querySearch ? '&' + querySearch : ''}" title="Page ${totalPages}">${totalPages}</a></span>`;
        }
    
        if (nextPage <= totalPages && nextPage > 0) {
            const nextButton = document.createElement('span');
            nextButton.className = 'next';
            nextButton.innerHTML = `<a href="?page=${nextPage}${querySearch ? '&' + querySearch : ''}" title="Next">→</a>`;
            paginationHtml.appendChild(nextButton);
        }
    
        paginationContainer.appendChild(paginationHtml);
    }



    async function createMobFilters(facets) {
        const filterMobContainer = document.getElementById('FacetFiltersFormMobile');
        filterMobContainer.querySelectorAll('.thb-filter').forEach(el => el.remove());
    
        if (!facets || facets.length === 0) {
            return;
        }
    
        facets.forEach((facet, index) => {
            if (facet.label ===  'search_query' || facet.label === 'collection_handle' || facet.label === 'Category'  || facet.label === "ss_available" || facet.label === "tags" || facet.label === "ss_has_tags") {
                return;
            }
            const facetMobElement = document.createElement('div');
            facetMobElement.className = 'thb-filter js-filter';
            facetMobElement.setAttribute('data-index', index + 1);
    
            const facetMobTitle = document.createElement('div');
            facetMobTitle.className = 'thb-filter-title';
            facetMobTitle.textContent = facet.label.replace("variant_", "");
    
            const facetDropdown = document.createElement('div');
            facetDropdown.className = 'thb-filter-dropdown';
    
            const facetInner = document.createElement('div');
            facetInner.className = 'thb-filter-dropdown__inner';
    
            let facetOptionsHTML = '';
    
            if (facet.type === 'range' || facet.type === 'slider') {
                const minPrice = facet.range[0];
                const maxPrice = facet.range[1];
                const step = getStep(minPrice, maxPrice);
                facetOptionsHTML = `
                    <div class="price_range price_range-${facet.field}">
                        <span class="price-highest">The highest price is $${maxPrice}</span>
                        <price-slider class="price_slider_wrapper">
                            <div class="slider">
                                <div class="progress"></div>
                            </div>
                            <div class="natori-range-input">
                                <input type="range" class="range-min" min="${minPrice}" max="${maxPrice}" value="${minPrice}" step="${step}">
                                <input type="range" class="range-max" min="${minPrice}" max="${maxPrice}" value="${maxPrice}" step="${step}">
                            </div>
                            <div class="price_slider_amount natori-price-input">
                                  <div class="field">
                                      <span class="field-currency">$</span>
                                      <input type="number" class="input-min" value="${minPrice}">
                                  </div>
                                  <div class="field">
                                      <span class="field-currency">$</span>
                                      <input type="number" class="input-max" value="${maxPrice}">
                                  </div>
                            </div>
                        </price-slider>
                    </div>
                `;
            } else if (facet.type === 'list' && facet.label != 'Price') {
                let optionsHTML = '';
                facet.values.forEach((value, valueIndex) => {
                    optionsHTML += `
                        <li>
                            <input type="checkbox" name="${facet.field}" value="${value.label}" id="Filter-${facet.field}-${valueIndex}">
                            <label for="Filter-${facet.field}-${valueIndex}" class="facet-checkbox" data-key="${value.value}">
                                ${value.label}
                            </label>
                            <span class="count">(${value.count})</span>
                        </li>
                    `;
                });

                facetOptionsHTML = `
                    <ul class="list-${facet.field.replace("variant_", "")}">
                        ${optionsHTML}
                    </ul>
                `;
            }

    
            facetInner.innerHTML = facetOptionsHTML;
            facetDropdown.appendChild(facetInner);
    
            const facetFooter = document.createElement('div');
            facetFooter.className = 'thb-filter-dropdown__footer';
            facetFooter.innerHTML = `
                <span class="facets__selected no-js-hidden">0 selected</span>
                <a href="/search/${querySearch}" class="facets__reset">
                    Reset
                </a>
            `;
    
            facetDropdown.appendChild(facetFooter);
            facetMobElement.appendChild(facetMobTitle);
            facetMobElement.appendChild(facetDropdown);
    
            const facetMobFooter = facetMobElement.querySelector('.thb-filter-dropdown__footer');
            if (facetMobFooter) {
              facetMobFooter.remove();
            }
            filterMobContainer.appendChild(facetMobElement);
        });
        attachFilterListeners();
    }
    
    async function createFilters(facets) {
        const filterContainer = document.querySelector('.facets__wrapper');
        filterContainer.querySelectorAll('.thb-filter').forEach(el => el.remove());
    
        if (!facets || facets.length === 0) {
            return;
        }
    
        facets.forEach((facet, index) => {
            if (facet.label === 'search_query' || facet.label === 'collection_handle' || facet.label === 'Category'  || facet.label === "ss_available" || facet.label === "tags" || facet.label === "ss_has_tags") {
                return;
            }
            const facetElement = document.createElement('details');
            facetElement.className = 'thb-filter';
            facetElement.setAttribute('data-index', index + 1);
            facetElement.setAttribute('data-type', facet.field.replace("variant_", ""));
    
            const facetSummary = document.createElement('summary');
            facetSummary.className = 'thb-filter-title';
            if (facet.type === 'range' || facet.type === 'slider') {
              facetSummary.textContent = facet.label.replace("variant_", "");
              facetSummary.style.textTransform = 'capitalize';
            }else{
              facetSummary.textContent = facet.label;
            }
    
            const facetDropdown = document.createElement('div');
            facetDropdown.className = 'thb-filter-dropdown';
    
            const facetInner = document.createElement('div');
            facetInner.className = 'thb-filter-dropdown__inner';
    
            let facetOptionsHTML = '';
    
            if (facet.type === 'range' || facet.type === 'slider') {
                const minPrice = facet.range[0];
                const maxPrice = facet.range[1];
                const step = getStep(minPrice, maxPrice);
                facetOptionsHTML = `
                    <div class="price_range price_range-${facet.field}">
                        <span class="price-highest">The highest price is $${maxPrice}</span>
                        <price-slider class="price_slider_wrapper">
                            <div class="slider">
                                <div class="progress"></div>
                            </div>
                            <div class="natori-range-input">
                                <input type="range" class="range-min" min="${minPrice}" max="${maxPrice}" value="${minPrice}" step="${step}">
                                <input type="range" class="range-max" min="${minPrice}" max="${maxPrice}" value="${maxPrice}" step="${step}">
                            </div>
                            <div class="price_slider_amount natori-price-input">
                                  <div class="field">
                                      <span class="field-currency">$</span>
                                      <input type="number" class="input-min" value="${minPrice}">
                                  </div>
                                  <div class="field">
                                      <span class="field-currency">$</span>
                                      <input type="number" class="input-max" value="${maxPrice}">
                                  </div>
                            </div>
                        </price-slider>
                    </div>
                `;
            } else if (facet.type === 'list' && facet.label != 'Price') {
                let optionsHTML = '';
                facet.values.forEach((value, valueIndex) => {
                    optionsHTML += `
                        <li>
                            <input type="checkbox" name="${facet.field}" value="${value.label}" id="Filter-${facet.field}-${valueIndex}">
                            <label for="Filter-${facet.field}-${valueIndex}" class="facet-checkbox" data-key="${value.value}">
                                ${value.label}
                            </label>
                            <span class="count">(${value.count})</span>
                        </li>
                    `;
                });

                facetOptionsHTML = `
                    <ul class="list-${facet.field.replace("variant_", "")}">
                        ${optionsHTML}
                    </ul>
                `;
            }
    
            facetInner.innerHTML = facetOptionsHTML;
            facetDropdown.appendChild(facetInner);
    
            const facetFooter = document.createElement('div');
            facetFooter.className = 'thb-filter-dropdown__footer';
            facetFooter.innerHTML = `
                <span class="facets__selected no-js-hidden">0 selected</span>
                <a href="/search/${querySearch}" class="facets__reset">
                    Reset
                </a>
            `;
            if (facet.type != 'range' && facet.type != 'slider') {
                facetDropdown.appendChild(facetFooter);  
            }
            facetElement.appendChild(facetSummary);
            facetElement.appendChild(facetDropdown);
    
            filterContainer.appendChild(facetElement);
        });

        attachFilterListeners();
    }

    const attachFilterListeners = () => {
        const filterInputs = document.querySelectorAll('.facets__wrapper input[type="checkbox"], .facets__wrapper input[type="text"], #FacetFiltersFormMobile input[type="checkbox"], #FacetFiltersFormMobile input[type="text"]');
        filterInputs.forEach(input => {
            input.addEventListener('change', (event) => {
                event.preventDefault();
                applyFilters();
            });
        });
    };    
    const updateFacetValues = async (facets) => {
          facets.forEach((facet) => {
              if (facet.type === 'list' && facet.label != 'Price') {
                  const facetName = facet.field.replace("variant_", "");
                  if (facetName !== 'collection_handle' && facetName !== 'Category' && facetName !== 'ss_available' && facetName !== 'tags' && facetName !== 'ss_has_tags') {
                      const facetContainers = document.querySelectorAll(`.thb-filter:has(ul.list-${facetName})`);
                      facetContainers.forEach((facetContainer) => {
                          facet.values.forEach((value) => {
                              if (value.active == true) {
                                  const activeInput = facetContainer.querySelector(`ul.list-${facetName} input[value="${value.label}"]`);
                                  if (activeInput) {
                                      activeInput.checked = true;
                                  }
                              }
                          });
                          let selectedFacets = 0;
                          const facetUl = facetContainer.querySelector(`ul.list-${facetName}`);
                          const checkedfacet = facetUl.querySelectorAll('input[type="checkbox"]');
                          checkedfacet.forEach((checkbox) => {
                              if (checkbox.checked) {
                                  selectedFacets++;
                              }
                          });
                          const facetCounter = facetContainer.querySelector(".thb-filter-dropdown__footer span.facets__selected");
                          if (facetCounter) {
                              facetCounter.textContent = `${selectedFacets} selected`;
                          }
                      });
                  }
              }
          });
    };

    const fetchProductsAndFilters = async (queryParams) => {
        try {
            if(pageLoad == true){
                queryParams.page  = 1;
            }
            const queryString = buildQueryString(queryParams);
            const url = `${baseUrl}?${queryString}`;
            const filterString = queryParams.filter;
            if(pageLoad == true){
                await updatePageParamToOne(); 
            }
            pageLoad = true;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            const data = await response.json();
            // console.log('Success:', data);
            if (data.results && data.pagination.totalResults > 0) {
                await createProductGrid(data.results, data.merchandising.content.inline, data.pagination);
                collectionContainer.classList.remove('ss-hide');
                collectionContainer.removeAttribute('style');
                productGridContainer.removeAttribute('style');      
                await createFilters(data.facets);   
                await createMobFilters(data.facets);   
                await updateFacetValues(data.facets);
                hideSpinner();
                await createSortingOptions(data.sorting);
                await createMobSortingOptions(data.sorting);
                await initializeCustomSwatches();
                await updateColorValue();
                await updateTitle(data.pagination.totalResults);
                await createAppliedFilters(filterString);
                await bindFilterListeners();
                productReviews();
                await priceRangeSlider();
                await updateFeatureImages();
                await removeAllFilters();
                await facetReset();
                await remClass();
            } else {
                const filterDesk = document.querySelector('facet-filters-form.facets-desktop-container');
                const filterMob = document.querySelector('.facets-mobile-container');
                await updateTitle(data.pagination.totalResults);
                document.querySelectorAll('.collection-container p.empty-result').forEach(p => p.remove());
                filterDesk.style.display = 'none';
                filterMob.style.display = 'none';
                const productGrid = document.getElementById('product-grid');
                const searchPagination = document.querySelector('pagination-theme.pagination');
                searchPagination.style.display = 'none';
                productGrid.innerHTML = '';
                productGrid.style.display = 'none';
                
                const emptyResult = document.createElement('div');
                emptyResult.classList.add('empty-result');
                emptyResult.innerHTML = `
                    <div class="row">
                        <div class="small-12 columns">
                            <div class="collection-empty">
                                <svg width="171" height="137" viewBox="0 0 171 137" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M77.5235 47.358C77.7471 47.4705 77.9987 47.5268 78.2503 47.5268C79.0052 47.5268 79.6761 47.0766 79.9837 46.4013C81.2417 43.5314 82.975 40.9148 85.1556 38.692C85.8545 37.9323 85.8266 36.7506 85.0718 36.0472C84.3169 35.3438 83.1428 35.3719 82.4438 36.1316C79.9837 38.692 77.9708 41.6744 76.545 44.9382C76.3493 45.3884 76.3493 45.923 76.517 46.3732C76.7127 46.7952 77.0762 47.161 77.5235 47.358Z" fill="var(--color-accent)"/>
                                    <path d="M91.5298 32.9522C91.8933 32.9522 92.2288 32.8397 92.5363 32.6708C95.2481 30.9545 98.1276 29.5196 101.119 28.366C102.069 28.0002 102.545 26.9029 102.181 25.9181C101.818 24.9615 100.728 24.4832 99.7491 24.849C96.5341 26.087 93.4589 27.6344 90.5514 29.4914C89.8524 29.9416 89.517 30.7857 89.7406 31.6017C89.9643 32.4176 90.6911 32.9522 91.5298 32.9522Z" fill="var(--color-accent)"/>
                                    <path d="M83.2266 71.8927C82.8631 72.2022 82.6115 72.6805 82.5836 73.187C82.5556 73.6935 82.6954 74.1718 83.0309 74.5657C85.2394 77.1823 87.6996 79.6021 90.2996 81.8248C90.6351 82.1343 91.0544 82.275 91.5017 82.275C92.0608 82.275 92.5641 82.0218 92.9554 81.5997C93.6264 80.8119 93.5146 79.6021 92.7318 78.9268C90.2716 76.8447 87.9792 74.5657 85.8824 72.1178C85.1835 71.33 84.0093 71.2175 83.2266 71.8927Z" fill="var(--color-accent)"/>
                                    <path d="M73.7214 131.485C70.9258 130.36 68.4097 128.615 66.3409 126.393C65.642 125.633 64.4678 125.549 63.713 126.252C62.9582 126.955 62.8743 128.137 63.5732 128.925C66.0054 131.626 69.0247 133.708 72.3795 135.059C72.6032 135.143 72.8268 135.171 73.0784 135.171C73.973 135.199 74.7558 134.552 74.9515 133.652C75.1193 132.751 74.644 131.879 73.8053 131.542L73.7214 131.485Z" fill="var(--color-accent)"/>
                                    <path d="M92.0051 131.851C89.0976 132.751 86.0783 133.23 83.059 133.23H82.7515C81.773 133.314 81.0461 134.13 81.0461 135.115C81.0461 136.1 81.773 136.916 82.7515 137H83.087C86.4977 136.972 89.8804 136.437 93.1234 135.424C94.1018 135.115 94.661 134.074 94.3535 133.089C94.0459 132.104 93.0115 131.542 92.0331 131.851H92.0051Z" fill="var(--color-accent)"/>
                                    <path d="M105.704 96.2024C106.095 96.2024 106.486 96.0618 106.822 95.8367C107.213 95.5553 107.493 95.1051 107.577 94.6268C107.661 94.1485 107.521 93.642 107.241 93.22C105.2 90.4345 102.908 87.8178 100.392 85.4544C99.6371 84.751 98.4629 84.7791 97.764 85.5107C97.0651 86.2704 97.0931 87.4521 97.8199 88.1555C100.168 90.3782 102.293 92.7698 104.222 95.3584C104.557 95.8929 105.117 96.2024 105.704 96.2024Z" fill="var(--color-accent)"/>
                                    <path d="M78.3343 55.2924C78.2784 54.2513 77.4117 53.4635 76.3774 53.4916C75.343 53.5479 74.5602 54.4201 74.5881 55.4612C74.7838 59.0626 75.7064 62.5796 77.272 65.7872C77.4397 66.2936 77.8311 66.6875 78.3064 66.8845C78.7816 67.0814 79.3407 67.0814 79.816 66.8563C80.2913 66.6313 80.6547 66.2374 80.7945 65.7309C80.9622 65.2244 80.9063 64.6899 80.6267 64.2397C79.3128 61.4261 78.5021 58.3873 78.3343 55.2924Z" fill="var(--color-accent)"/>
                                    <path d="M109.841 101.295C109.366 101.464 109.003 101.802 108.779 102.252C108.555 102.702 108.555 103.237 108.723 103.687C109.562 105.994 110.009 108.442 110.009 110.89C110.009 111.509 109.981 112.099 109.925 112.69C109.841 113.731 110.596 114.632 111.603 114.744H111.742C112.721 114.744 113.504 114.013 113.615 113.028C113.699 112.296 113.727 111.593 113.727 110.861C113.699 107.963 113.168 105.094 112.162 102.364C111.798 101.492 110.792 101.014 109.841 101.295Z" fill="var(--color-accent)"/>
                                    <path d="M109.478 120.681C109.059 120.4 108.555 120.315 108.08 120.4C107.605 120.512 107.158 120.794 106.906 121.216C105.201 123.804 102.992 126.027 100.448 127.771C100.029 128.053 99.749 128.503 99.6652 128.981C99.5813 129.459 99.6931 129.966 99.9727 130.388C100.252 130.81 100.672 131.091 101.175 131.176C101.678 131.26 102.181 131.148 102.573 130.866C105.536 128.84 108.052 126.252 110.037 123.27C110.568 122.397 110.345 121.244 109.478 120.681Z" fill="var(--color-accent)"/>
                                    <path d="M119.878 20.9099C116.439 20.938 113 21.3038 109.646 21.979C108.695 22.1478 108.024 23.0482 108.136 24.0048C108.22 24.9615 109.031 25.7211 110.009 25.693H110.372C113.532 25.074 116.719 24.7364 119.934 24.7082C120.912 24.6238 121.639 23.8079 121.639 22.8231C121.639 21.8383 120.912 21.0224 119.934 20.938L119.878 20.9099Z" fill="var(--color-accent)"/>
                                    <path d="M72.8268 120.934C73.2741 120.006 72.9107 118.88 71.9881 118.402C68.2979 116.601 64.3001 115.532 60.1905 115.251V51.7472C60.1905 51.6347 60.1905 51.5221 60.1905 51.4096V15.4514C61.9517 14.8606 63.3216 13.4538 63.8807 11.6531C64.4399 9.88047 64.1323 7.91094 63.0141 6.41972C61.9517 4.90036 60.1905 4 58.3453 4C56.5002 4 54.7389 4.90036 53.6207 6.39158C52.5304 7.91094 52.1949 9.85234 52.754 11.6249C53.3132 13.3975 54.683 14.8325 56.4443 15.4233V17.3366C51.0766 14.2697 39.5026 9.73979 28.5996 19.5312C16.103 30.7857 3.215 25.0178 2.68383 24.7645C1.87309 24.3706 0.922566 24.6239 0.391391 25.3273C-0.139783 26.0588 -0.0838704 27.0436 0.531174 27.7188L7.77192 35.8221L1.23009 42.3497C0.866653 42.7155 0.643 43.2219 0.670957 43.7284C0.670957 44.2348 0.922566 44.7413 1.286 45.0789C1.42578 45.1915 15.8234 57.9653 30.7522 47.2735C36.1478 43.4189 41.3478 42.209 46.2401 43.644C50.4895 45.0508 54.1239 47.9207 56.4723 51.7753V115.645C53.3411 116.376 50.3498 117.614 47.638 119.33C46.8831 119.949 46.6875 121.019 47.2186 121.863C47.7498 122.679 48.8122 122.96 49.6788 122.482C49.6788 122.482 54.9346 119.049 59.7991 119.049C63.4614 119.274 67.0119 120.203 70.3107 121.806C71.2613 122.228 72.3795 121.863 72.8268 120.934ZM56.2486 9.90861C56.2486 9.06452 56.7518 8.27671 57.5346 7.93907C58.3174 7.60144 59.212 7.77026 59.827 8.38925C60.4421 8.98011 60.6098 9.90861 60.3023 10.6964C59.9668 11.4842 59.212 11.9907 58.3733 11.9907C57.1991 12.0188 56.2486 11.0622 56.2486 9.90861ZM51.6637 41.9277C46.6875 39.0015 38.636 37.0319 28.5996 44.2067C18.5632 51.3814 9.05793 46.1199 5.36766 43.5033L11.6299 37.2008C12.3568 36.4974 12.3848 35.3438 11.7138 34.6122L7.49236 29.8853C16.103 31.1515 24.7975 28.3941 31.1157 22.4011C42.0746 12.6097 53.5368 19.7 56.4723 21.8102V45.726C55.0185 44.263 53.425 42.9968 51.6637 41.9277Z" fill="var(--color-accent)"/>
                                    <path d="M162.552 8.8313L131.615 8.8313C130.838 8.8313 130.209 9.4609 130.209 10.2375L130.209 35.55C130.209 36.3267 130.838 36.9563 131.615 36.9563L162.552 36.9563C163.329 36.9563 163.959 36.3267 163.959 35.5501L163.959 10.2376C163.959 9.4609 163.329 8.8313 162.552 8.8313Z" stroke="#3B3B3B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M130.209 14.4565L163.959 14.4565" stroke="#3B3B3B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M154.115 20.0815C154.115 21.9463 153.374 23.7347 152.056 25.0533C150.737 26.3719 148.949 27.1127 147.084 27.1127C145.219 27.1127 143.431 26.3719 142.112 25.0533C140.793 23.7347 140.052 21.9463 140.052 20.0815" stroke="#3B3B3B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M149.467 7.01943L152.707 3.11465C153.161 2.55128 153.082 1.73536 152.509 1.28854C151.936 0.841726 151.106 0.919433 150.652 1.48281L147.511 5.30987L144.607 1.57994C144.132 1.1137 143.401 1.05542 142.868 1.46338C142.335 1.85192 142.177 2.57071 142.512 3.13408L145.535 7L142.295 10.8853C141.841 11.4487 141.92 12.2646 142.473 12.7115C143.046 13.1583 143.876 13.0806 144.33 12.5172L147.471 8.74841L150.336 12.4589C150.593 12.7892 150.968 12.964 151.383 12.964C151.679 12.964 151.956 12.8669 152.173 12.692C152.45 12.4783 152.628 12.1675 152.687 11.8373C152.726 11.4876 152.647 11.1573 152.43 10.8853L149.467 7.01943Z" fill="var(--color-accent)"/>
                                </svg>
                                <p>No results found for “${queryParams.bgfilter.search_query}”. Check the spelling or use a different word or phrase.</p>
                            </div>
                        </div>
                    </div>
                `;
                const gridContainer = document.getElementById('ProductGridContainer');
                collectionContainer.insertBefore(emptyResult, gridContainer);
                
                collectionContainer.classList.remove('ss-hide');
                collectionContainer.removeAttribute('style');
                productGridContainer.removeAttribute('style');   
          }
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            await hideSpinner();
        }
    };

    const createMobSortingOptions = async (sortingData) => {
        const oldSort = document.querySelector('.thb-filter-sort-count.thb-filter');
        if (oldSort) {
            oldSort.remove();
        }
    
        const sortContainer = document.createElement('div');
        sortContainer.classList = "thb-filter-sort-count thb-filter";
    
        const sortFilter = document.createElement('div');
        sortFilter.classList = "thb-filter-sort";
    
        const sortTitle = document.createElement('div');
        sortTitle.classList = "thb-filter-title";
        sortTitle.textContent = "Sort by";
    
        const sortSelect = document.createElement('div');
        sortSelect.classList = "select";
    
        const sortingSelect = document.createElement('select');
        sortingSelect.id = 'SortBy';
        sortingSelect.style.minWidth = "160px";
    
        sortingData.options.forEach(option => {
            const sortOption = document.createElement('option');
            sortOption.value = `${option.field}-${option.direction}`;
            sortOption.textContent = option.label;
            if (option.active) {
                sortOption.selected = true;
            }
            sortingSelect.appendChild(sortOption);
        });
    
        const sortLabel = document.createElement('label');
        sortLabel.setAttribute('for', 'SortByMobile');
        sortLabel.classList.add('visually-hidden');
        sortLabel.textContent = 'Sort by';
    
        sortSelect.appendChild(sortLabel);
        sortSelect.appendChild(sortingSelect);
    
        sortFilter.appendChild(sortTitle);
        sortFilter.appendChild(sortSelect);
    
        sortContainer.appendChild(sortFilter);
    
        const filterMobContainer = document.getElementById('FacetFiltersFormMobile');
        filterMobContainer.appendChild(sortContainer);
        await bindMobSortingfunction();
    };


    const createSortingOptions = async (sortingData) => {
        const sortingSelect = document.getElementById('SortBy');
        sortingSelect.style.minWidth = "160px";
        sortingSelect.innerHTML = ''; // Clear existing options
    
        sortingData.options.forEach(option => {
            const sortOption = document.createElement('option');
            sortOption.value = `${option.field}-${option.direction}`;
            sortOption.textContent = option.label;
            if (option.active) {
                sortOption.selected = true;
            }
            sortingSelect.appendChild(sortOption);
        });
    };


    const createAppliedFilters = async (filterString) => {
        if (!filterString || typeof filterString !== 'object') return;

        const filterSelectElements = document.querySelectorAll('facet-remove.active-facets');
        if (!filterSelectElements.length) return;
        let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
        const updatedFilters = { ...storedFilters, ...filterString };
        sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilters));

        filterSelectElements.forEach(filterSelect => {
            filterSelect.querySelectorAll('.active-facets__button').forEach(el => el.remove());

            Object.keys(updatedFilters).forEach(key => {
                const filterValue = updatedFilters[key];

                if (!filterValue || filterValue.length === 0 || key === "search_query" || key === "collection_handle" || key === "ss_available" || key === "tags" || key === "ss_has_tags") return;
                if(key == 'variant_price'){
                    const lowPrices = {};
                    const highPrices = {};
                    if (typeof filterValue === 'object' && filterValue !== null && 'low' in filterValue && 'high' in filterValue) {
                        lowPrices[key] = filterValue.low;
                        highPrices[key] = filterValue.high;
                    }
                    const currentUrl = new URL(window.location.href);
                    const filterLink = document.createElement('a');
                    filterLink.href = currentUrl.toString();
                    filterLink.classList.add('active-facets__button');
                    filterLink.innerHTML = `
                        Price range : ${lowPrices[key] || 'N/A'} - ${highPrices[key] || 'N/A'}
                        <span>
                            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.4731 6.875C6.60027 6.875 6.72968 6.82592 6.82561 6.72775C7.01972 6.53364 7.01972 6.21682 6.82561 6.02049L4.67929 3.87416L6.82561 1.72784C7.01972 1.53373 7.01972 1.21692 6.82561 1.02058C6.63151 0.826473 6.31469 0.826473 6.11835 1.02058L3.97203 3.1669L1.82794 1.02504C1.63383 0.830936 1.31701 0.830936 1.12068 1.02504C0.926571 1.21915 0.926571 1.53596 1.12068 1.7323L3.267 3.87863L1.12291 6.02049C0.928802 6.21459 0.928802 6.53141 1.12291 6.72775C1.22108 6.82592 1.34825 6.875 1.47542 6.875C1.6026 6.875 1.732 6.82592 1.82794 6.72775L3.97426 4.58142L6.12058 6.72775C6.21652 6.82592 6.34593 6.875 6.4731 6.875Z" fill="var(--color-accent)"></path>
                            </svg>
                        </span>
                    `;

                    const removeButton = filterSelect.querySelector('a.active-facets__button-remove');
                    if (removeButton) {
                        filterSelect.insertBefore(filterLink, removeButton);
                    } else {
                        filterSelect.appendChild(filterLink);
                    }
                } else {
                    if (Array.isArray(filterValue)) {
                        filterValue.forEach(value => {
                            appendFilterElement(key, value, filterSelect, updatedFilters);
                        });
                    } else {
                        appendFilterElement(key, filterValue, filterSelect, updatedFilters);
                    }
                }
            });
        });
    };

    const  handleProductCardHover = async () => {
        const productCards = document.querySelectorAll('product-card.product-card');
    
        productCards.forEach((productCard) => {
            const swatches = productCard.querySelector('.product-card-swatches');
            const image = productCard.querySelector('.product-featured-image-link .product-primary-image');
            const href = productCard.querySelector('.product-featured-image-link');
            const secondary = productCard.querySelector('.product-featured-image-link .product-secondary-image');
            const swatchList = swatches ? swatches.querySelectorAll('.product-card-swatch') : [];
    
            swatchList.forEach((swatch) => {  
                swatch.addEventListener('mouseover', () => {   
                  swatchList.forEach((el) => {
                      el.classList.remove('active');
                  });
                  swatch.classList.add('active');
                  const primaryDataset = swatch.getAttribute('data-srcset');
                  const secondaryDataset = swatch.getAttribute('data-srcset-2');
                  const urlDataset = swatch.getAttribute('data-href');
                    if(urlDataset){
                      href.setAttribute('href', urlDataset);
                    }
                    if (image) {   
                        if (primaryDataset) {
                            image.setAttribute('srcset', primaryDataset);
                        }
                        if (secondary) {
                            if (secondaryDataset) {
                                secondary.setAttribute('srcset', secondaryDataset);
                            }
                        }
                    }
                });
            });
        });
    };

    const appendFilterElement = async(key, value, filterSelect, updatedFilters) => {
        const filterLink = document.createElement('a');
        filterLink.href = generateFilterUrl(key, updatedFilters);
        filterLink.classList.add('active-facets__button');
        
        if (key === 'variant_color') {
            filterLink.classList.add('active-facets__button--color');
            const colorKey = value.trim();
            
            if (colorKey) {
                const styleValue = await fetchColorValue(colorKey);
                const styles = styleValue.split(';').filter(Boolean);

                styles.forEach(style => {
                    const [property, value] = style.split(':').map(s => s.trim());
                    if (property && value) {
                        filterLink.style.setProperty(property, value);
                    }
                });
            } else {
                filterLink.style.setProperty('--bg-color', `var(--bg-body)`);
                filterLink.style.setProperty('--option-color-image', 'url(false)');
            }
        }

    
        filterLink.innerHTML = `
            ${value}
            <span>
              <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.4731 6.875C6.60027 6.875 6.72968 6.82592 6.82561 6.72775C7.01972 6.53364 7.01972 6.21682 6.82561 6.02049L4.67929 3.87416L6.82561 1.72784C7.01972 1.53373 7.01972 1.21692 6.82561 1.02058C6.63151 0.826473 6.31469 0.826473 6.11835 1.02058L3.97203 3.1669L1.82794 1.02504C1.63383 0.830936 1.31701 0.830936 1.12068 1.02504C0.926571 1.21915 0.926571 1.53596 1.12068 1.7323L3.267 3.87863L1.12291 6.02049C0.928802 6.21459 0.928802 6.53141 1.12291 6.72775C1.22108 6.82592 1.34825 6.875 1.47542 6.875C1.6026 6.875 1.732 6.82592 1.82794 6.72775L3.97426 4.58142L6.12058 6.72775C6.21652 6.82592 6.34593 6.875 6.4731 6.875Z" fill="var(--color-accent)"></path>
              </svg>
            </span>
        `;
    
        const removeButton = filterSelect.querySelector('a.active-facets__button-remove');
        filterSelect.insertBefore(filterLink, removeButton);
    };
    
    const generateFilterUrl = async (currentKey, updatedFilters) => {
        const currentUrl = new URL(window.location.href);
    
        currentUrl.searchParams.delete(currentKey);
    
        Object.keys(updatedFilters).forEach(key => {
            if (updatedFilters[key]) {
              if(key !== "search_query" || key !== "collection_handle" || key !== "Category" || key != "ss_available" || key != "tags" || key != "ss_has_tags"){
                if (Array.isArray(updatedFilters[key])) {
                    updatedFilters[key].forEach(value => {
                        currentUrl.searchParams.append(key, value);
                    });
                } else {
                    currentUrl.searchParams.set(key, updatedFilters[key]);
                }
              }
            }
        });
    
        return currentUrl.toString();
    };

    const updateFeatureImages = async () => {
        const featuredImages = document.querySelectorAll('figure.product-featured-image');
    
        featuredImages.forEach((figure) => {
            const secondaryImage = figure.querySelector('img.product-secondary-image');
            
            if (!secondaryImage) {
                figure.classList.remove('thb-hover');
            } else {
                figure.classList.add('thb-hover');
            }
        });
    };

    const applyFilters = async () => {
        document.querySelectorAll('.facets__form details.thb-filter').forEach((detailElement) => {
            detailElement.removeAttribute('open');
        });
        const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
        if (filterSidebar) {
            filterSidebar.classList.remove('active');
        }
        const body = document.querySelector('body');
        if (body) {
            body.classList.remove('open-cc');
        }
    
        const filterInputs = document.querySelectorAll('.facets__wrapper input[type="checkbox"]:checked, .facets__wrapper input[type="text"], #FacetFiltersFormMobile input[type="checkbox"]:checked, #FacetFiltersFormMobile input[type="text"]');
        const filterParams = { ...queryParams.filter };
        
        filterInputs.forEach(input => {
            const name = input.name;
            const value = input.value;
        
            if (!filterParams[name]) {
                filterParams[name] = input.type === 'checkbox' ? [] : '';
            }
        
            if (input.type === 'checkbox') {
                if (Array.isArray(filterParams[name])) {
                    if (!filterParams[name].includes(value)) {
                        filterParams[name].push(value);
                    }
                } else {
                    filterParams[name] = [value];
                }
            } else if (input.type === 'text') {
                filterParams[name] = value;
            }
        });
        
        queryParams.filter = filterParams;
        queryParams.page = 1; // Reset to the first page
    
        fetchProductsAndFilters(queryParams);
    };

    const remClass = async () => {
        const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
        if (filterSidebar) {
            filterSidebar.classList.remove('active');
        }
    
        const body = document.querySelector('body');
        if (body) {
            body.classList.remove('open-cc');
        }

        const remLoadingGird = document.getElementById('product-grid');
        if(remLoadingGird){
            remLoadingGird.classList.remove('loading');
        }
    
        const removeLoading = document.querySelectorAll(
            'span.thb-filter-count.mobile-filter-count.body-font, .facets-mobile-container .thb-filter-count'
        );
    
        removeLoading.forEach(remEle => {
            remEle.classList.remove('loading');
        });
    };

    document.getElementById('SortBy').addEventListener('change', async function(event) {
        const [field, direction] = event.target.value.split('-');
        queryParams.sort = { [field]: direction };
        const updatedSortString = { [field]: direction };
        sessionStorage.setItem('natoriSort', JSON.stringify(updatedSortString));
        queryParams.page = 1; // Reset to the first page

        fetchProductsAndFilters(queryParams);
    });

    async function updateQueryParams(queryParams) {
        let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
        let storedSort = JSON.parse(sessionStorage.getItem('natoriSort') || '{}');
    
        if (Object.keys(storedFilters).length > 0) {
            queryParams.filter = {
                ...queryParams.filter,
                ...storedFilters
            };
        }
        
        if (Object.keys(storedSort).length > 0) {
            queryParams.sort = storedSort;
        }
    
        return queryParams;
    }

    const bindMobSortingfunction = async () => {
        const sortByElement = document.querySelector('#FacetFiltersFormMobile .thb-filter-sort #SortBy');
        if (sortByElement) {
            const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
            if (filterSidebar) {
                filterSidebar.classList.remove('active');
            }
            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('open-cc');
            }
            sortByElement.addEventListener('change', function(event) {
                const [field, direction] = event.target.value.split('-');
                queryParams.sort = { [field]: direction };
                const updatedSortString = { [field]: direction };
                sessionStorage.setItem('natoriSort', JSON.stringify(updatedSortString));
                queryParams.page = 1;
                fetchProductsAndFilters(queryParams);
            });
        } else {
            console.error('Sorting element not found. Unable to bind event listener.');
        }
    };

    const bindFilterListeners = async () => {
        const removeFilterButtons = document.querySelectorAll('facet-remove.active-facets .active-facets__button');
        removeFilterButtons.forEach(remBtn => {
            remBtn.addEventListener('click', async (event) => {
                event.preventDefault();
    
                const valueText = Array.from(remBtn.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).map(textNode => textNode.textContent.trim()).join(' ');
                const normalizedValueText = valueText.trim();  
    
                const updatedFilterString = Object.entries(queryParams.filter).reduce((acc, [key, values]) => {
                    if (Array.isArray(values)) {
                        const filteredValues = values.map(value => value.trim()).filter(value => value !== normalizedValueText);
                        if (filteredValues.length > 0) {
                            acc[key] = filteredValues;
                        }
                    } else {
                        acc[key] = values;
                    }
                    return acc;
                }, {});

                if (normalizedValueText.includes('Price range :')) {
                    delete updatedFilterString['variant_price'];
                }
    
                queryParams.filter = updatedFilterString;
    
                sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilterString));
                fetchProductsAndFilters(queryParams);
            });
        });
    };

    const removeAllFilters = async () => {
        const removeAllFilterButtons = document.querySelectorAll('.active-facets__button-remove');
    
        if (removeAllFilterButtons.length > 0) {
            removeAllFilterButtons.forEach(button => {
                button.addEventListener('click', async (event) => {
                    event.preventDefault();
    
                    const updatedFilterString = {};
                    queryParams.filter = updatedFilterString;
                    pageLoad = true;
                    sessionStorage.removeItem('natoriFacetsData');
                    sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilterString));
    
                    await fetchProductsAndFilters(queryParams);
                });
            });
        } else {
            console.warn('Remove all filter buttons not found.');
        }
    };

    const updateReviewStars = async () => {
        const productInfoRights = document.querySelectorAll('#ProductGridContainer #product-grid li.column .productInfosection .productInfoRight');
    
        productInfoRights.forEach(productInfoRight => {
            const plpRatings = productInfoRight.querySelector('.plpRatings');
            if (plpRatings) {
                const yotpoStar = plpRatings.querySelector('.yotpo .yotpo-bottomline .yotpo-icon-star');
                if (!yotpoStar) {
                    plpRatings.remove();
                }
            }
        });
    };

    const updateTitle = async (resultCount) => {
        const searchQuery = urlParams.get('q') || 'pajama';
    
        let titleMessage;
    
        if (resultCount === 0) {
            titleMessage = `No results found for "${searchQuery}"`;
        } else {
            const pluralSuffix = resultCount === 1 ? '' : 's';
            titleMessage = `${resultCount} result${pluralSuffix} found for "${searchQuery}"`;
        }
        const newTitle = `Search: ${titleMessage} – Natori`;
        document.title = newTitle;
        await hideSpinner();
    };

    const updatePageParamToOne = async () => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.set('page', 1);
        window.history.pushState({}, '', `${url.pathname}?${params.toString()}`);
    };

    document.querySelector('#main-content .page-header--wrapper .page-header__inner form.searchform fieldset .thb-search-submit').addEventListener('click', function(event) {
        event.preventDefault();
        const searchQuery = document.querySelector('#main-content .page-header--wrapper .page-header__inner form.searchform input.search-field[type="search"]');
        const url = new URL(window.location);
        let sessionFilters = JSON.parse(sessionStorage.getItem('natoriFilters')) || {};
        if (searchQuery.value !== '') {
            sessionFilters.search_query = searchQuery.value;
            queryParams.q = searchQuery.value;   
            queryParams.page = 1;
            queryParams.bgfilter.search_query = searchQuery.value;
            url.searchParams.set('q', searchQuery.value);
        } else {
            sessionFilters.search_query = 'pajama';
            queryParams.q = 'pajama';
            queryParams.page = 1;
            queryParams.bgfilter.search_query = 'pajama';
            searchQuery.value = 'pajama';
            url.searchParams.set('q', 'pajama');
        }
        sessionStorage.setItem('natoriFilters', JSON.stringify(sessionFilters));
        window.history.replaceState({}, '', url);
        const autocompleteTarget = document.querySelectorAll('#ss__autocomplete--target');
        autocompleteTarget.forEach(element => {
            element.style.display = 'none';
            element.textContent = '';
        });
        fetchProductsAndFilters(queryParams);
    });

    document.querySelector('#main-content .page-header--wrapper .page-header__inner form.searchform').addEventListener('submit', function(event) {
        event.preventDefault();
        const searchQuery = document.querySelector('#main-content .page-header--wrapper .page-header__inner form.searchform input.search-field[type="search"]');
        const url = new URL(window.location);
        let sessionFilters = JSON.parse(sessionStorage.getItem('natoriFilters')) || {};
        if (searchQuery.value !== '') {
            sessionFilters.search_query = searchQuery.value;
            queryParams.q = searchQuery.value;    
            queryParams.page = 1;
            queryParams.bgfilter.search_query = searchQuery.value;
            url.searchParams.set('q', searchQuery.value);
        } else {
            sessionFilters.search_query = 'pajama';
            queryParams.q = 'pajama';
            queryParams.page = 1;
            queryParams.bgfilter.search_query = 'pajama';
            searchQuery.value = 'pajama';
            url.searchParams.set('q', 'pajama');
        }
        sessionStorage.setItem('natoriFilters', JSON.stringify(sessionFilters));
        window.history.replaceState({}, '', url);
        const autocompleteTarget = document.querySelectorAll('#ss__autocomplete--target');
        autocompleteTarget.forEach(element => {
            element.style.display = 'none';
            element.textContent = '';
        });
        fetchProductsAndFilters(queryParams);
    });

    const initializeCustomSwatches = async () => {
        if (abortController) {
            abortController.abort();
        }
        abortController = new AbortController();
    
        const fetchProductDetails = async (tag) => {
          const storefrontAccessToken = 'e37d6f5fced72df1026762e8fcf43b21';
          const url = `https://${shopUrl}/api/2024-10/graphql.json`;

          const productQuery = `
              query Products($query: String!, $country: CountryCode) @inContext(country: $country) {
                  products(first: 100, query: $query) {
                      edges {
                          node {
                              id
                              title
                              handle
                              discontinued: metafield(namespace: "custom", key: "discontinued") {
                                  value
                                  type
                              }
                              variantSwatchColor: metafield(namespace: "custom", key: "variant_swatch_color") {
                                  value
                                  type
                              }
                              totalInventory
                              priceRange {
                                  maxVariantPrice {
                                      amount
                                      currencyCode
                                  }
                                  minVariantPrice {
                                      amount
                                      currencyCode
                                  }
                              }
                              images(first: 2) {
                                  edges {
                                      node {
                                          src
                                          altText
                                      }
                                  }
                              }
                              variants(first: 100) {
                                  edges {
                                      node {
                                          id
                                          title
                                          quantityAvailable
                                          compareAtPrice {
                                              amount
                                              currencyCode
                                          }
                                          selectedOptions {
                                              name
                                              value
                                          }
                                          image {
                                              src
                                              altText
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          `;
      
          try {
              const response = await fetch(url, {
                  method: "POST",
                  headers: {
                      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                      query: productQuery,
                      variables: {
                          query: `tag:${tag}`,
                          country: Shopify.country
                      }
                  }),
                  signal: abortController.signal
              });
      
              const { data, errors } = await response.json();
      
              if (errors) {
                  console.error('GraphQL Errors:', errors);
                  return null;
              }
      
              if (data && data.products.edges) {
                  const productDetails = data.products.edges
                    .map(({ node }) => {
                        if (node) {
                            return node;
                        } else {
                            console.warn("Encountered a null product.");
                            return null;
                        }
                    })
                    .filter(Boolean);
      
                  return productDetails;
              } else {
                  console.warn("No product data found.");
                  return null;
              }
          } catch (error) {
              console.error("Error fetching product:", error);
              return []; // Return an empty array on error to prevent breaking subsequent code
          }
      };

    
        const processProductDetails = async ( product, keyArray, valArray, featuredImageId, productDataElements, productId, primaryImagesrc, secondaryImagesrc, mainHandle, uniqueColors, counter, productAvailable ) => {
            if (product && product.variants && product.variants.edges) {
                let storedVariants = JSON.parse(sessionStorage.getItem('natoriCustomVariants') || '{}');
                let customVarList = storedVariants[productId]?.variants || [];
                for (const edge of product.variants.edges) {
                    const variant = edge.node;
                    const productQuan = productAvailable;
                    if (variant) {
                        let variantCustomId = parseInt(variant.id.split("/").pop());
                        if (!customVarList.includes(variantCustomId)) {
                            for (const option of variant.selectedOptions) {
                                if (option.name.toLowerCase() === "color" || option.name.toLowerCase() === "colour" || option.name.toLowerCase() === "couleur") {
                                    const key = option.value;
                                    if (!uniqueColors.has(key) && counter.count < 6) {
                                        uniqueColors.set(key, option);
                                        if (option.value.length > 0) {
                                            let swatchHtml = "";
                                            let active = "";
                                            let variantImage = "";
                                            let variantUrl = "";
                                            let srcset = "";
                                            let variantId = parseInt(variant.id.split("/").pop());
                                            if (variant) {
                                                if (variantId === featuredImageId) {
                                                    active = "active";
                                                }
                                                if (primaryImagesrc) {
                                                    variantImage = primaryImagesrc;
                                                }
                                                variantUrl = `/products/${product.handle}?variant=${variantId}`;
                                            }
                                            const imageSizes = "{{ sizes }}".split(",");
    
                                            if (variantImage) {
                                                imageSizes.forEach((size) => {
                                                    const sizeArray = size.split("x");
                                                    const sizeX = sizeArray[0] + "x" + (sizeArray[1] !== "0" ? sizeArray[1] : "");
                                                    srcset += `${variantImage.replace(".jpg", `_${sizeX}.jpg`)} ${sizeArray[0]}w, `;
                                                });
                                            }
                                            let colorValue = key.toLowerCase().trim();
                                            const customColorIndex = keyArray.indexOf(colorValue);
                                            if (customColorIndex > -1) {
                                                colorValue = valArray[customColorIndex];
                                            }
                                            let bgValue = false;
                                            const swatchColor = product.variantSwatchColor?.value;
                                            if (swatchColor) {
                                                const swatchParts = swatchColor.split('-');
                                                const lastPart = swatchParts[swatchParts.length - 1].trim();
                                                if (lastPart.includes('#')) {
                                                    colorValue = lastPart;
                                                } else {
                                                    bgValue = lastPart;
                                                    colorValue = "var(--bg-body)";
                                                }
                                            } else {
                                                if (colorValue.includes(".")) {
                                                    bgValue = colorValue;
                                                    colorValue = "var(--bg-body)";
                                                }
                                            }
                                            const shopDomain = window.location.hostname;
                                            const bgImageUrl = bgValue ? `--option-color-image: url('//${shopDomain}/cdn/shop/files/${bgValue}');` : "";
                                            swatchHtml += `
                                                <div class="product-card-swatch ${active}"
                                                    style="--option-color: ${colorValue}; ${bgImageUrl}" 
                                                    data-srcset-2="${secondaryImagesrc}" 
                                                    data-srcset="${variantImage}"
                                                    data-href="${variantUrl}"
                                                    data-quan="${productQuan}">
                                                    <span class="visually-hidden">${key}</span>
                                                </div>
                                            `;
                                            if (productDataElements) {
                                                const existingSwatches = productDataElements.querySelectorAll('.product-card-swatch');
                                                const isSwatchExists = existingSwatches.length > 0 && productDataElements.querySelector(`.product-card-swatch[data-href="${variantUrl}"]`);
                                                if (!isSwatchExists && existingSwatches.length < 6) {
                                                    productDataElements.insertAdjacentHTML("beforeend", swatchHtml);
                                                    counter.count++;
                                                }
                                            }

                                        }
                                    }
                                }
                            }
                            if (counter.count >= 6) break;
                            customVarList.push(variantCustomId);
                        }
                    }
                }
    
                storedVariants[productId] = { variants: customVarList };
                sessionStorage.setItem('natoriCustomVariants', JSON.stringify(storedVariants));
    
                if (uniqueColors.size > 5 && counter.count > 5) {
                    const moreButtonHtml = `<div class="morebtn"><a href="${mainHandle}" intellisuggest="" ss-ps="">+ More</a></div>`;
                    productDataElements.insertAdjacentHTML("beforeend", moreButtonHtml);
                }
            }
        };
    
        const handleCustomSwatches = async () => {
            sessionStorage.removeItem('natoriCustomVariants');
            const productCards = document.querySelectorAll(".product-card-swatch");
        
            for (const card of productCards) {
                const prodOldSwatches = card.querySelector('.product-card-swatches');
                if (prodOldSwatches) {
                    prodOldSwatches.innerHTML = '';
                }
        
                const productId = card.getAttribute('data-product-id');
                const productStyleNo = card.getAttribute('data-style-no');
                const productName = card.getAttribute('data-product-name');
                const color_settings = window['settings'];
                const settings = window[`settings_${productId}`];
        
                const customColorsArray = color_settings.color_swatches.split(',').map(color => {
                    const [key, value] = color.split(':').map(part => part.trim());
                    return { key: key.toLowerCase(), value: value || '' };
                });
        
                const keyArray = customColorsArray.map(color => color.key);
                const valArray = customColorsArray.map(color => color.value);
        
                let productDetails;
                try {
                    productDetails = await fetchProductDetails(productStyleNo);
                } catch (error) {
                    console.error('Error fetching product details:', error);
                    continue;
                }
        
                let uniqueColors = new Map();
                let counter = { count: 0 };
        
                const secondaryImageSrc = productDetails .filter(pd => pd.id === `gid://shopify/Product/${productId}`) .flatMap(pd => pd.images.edges) .map(edge => edge.node.src)[1];
                const prodCard = document.querySelector(`product-card.product-card:has(.product-card-swatch[data-product-id='${productId}'])`);
                const prodImage = prodCard.querySelector('figure.product-featured-image img.product-primary-image');
                const featuredImage = prodCard.querySelector('figure.product-featured-image');
                const prodImageContainer = prodCard.querySelector('figure.product-featured-image .product-featured-image-link');
                if(secondaryImageSrc){
                    const prodSecondaryImage = document.createElement('img');
                    prodSecondaryImage.src = secondaryImageSrc;
                    prodSecondaryImage.alt = prodImage.alt ?? productName;
                    prodSecondaryImage.style.width = '100%';
                    prodSecondaryImage.style.height = '100%';
                    prodSecondaryImage.classList.add('product-secondary-image');
                    prodImageContainer.insertBefore(prodSecondaryImage, prodImage);
                    featuredImage.classList.add('thb-hover');
                  }
        
                const minPrice = Math.min(...productDetails.filter(pd => pd.totalInventory > 0).map(pd => pd.priceRange.minVariantPrice.amount));
                const maxPrice = Math.max(...productDetails.filter(pd => pd.totalInventory > 0).map(pd => pd.priceRange.maxVariantPrice.amount));
                const compareAtPrice = Math.min( ...productDetails .filter(pd => pd.totalInventory > 0) .flatMap(pd => pd.variants.edges.map(edge => edge.node?.compareAtPrice?.amount).filter(amount => amount != null)) ) || undefined;
        
                const prodPrices = prodCard.querySelector('.product-card-info .productInfoRight span.price');
                const priceContainer = minPrice !== maxPrice
                    ? `<ins><span class="amount">${moneyFormat}${formatPrice(minPrice)} - ${moneyFormat}${formatPrice(maxPrice)}</span></ins>`
                    : `<ins><span class="amount">${moneyFormat}${formatPrice(maxPrice)}</span></ins>`;
                const comparePriceContainer = compareAtPrice > minPrice ? `<del><span class="amount">${moneyFormat}${formatPrice(compareAtPrice)}</span></del>` : '';
                if (isFinite(minPrice) && isFinite(maxPrice) && (compareAtPrice === undefined || isFinite(compareAtPrice))) {
                    prodPrices.innerHTML = comparePriceContainer + priceContainer;
                }
                prodCard.classList.remove('hide-price');
        
                for (const productDetail of productDetails) {
                    if (abortController.signal.aborted) return;
        
                    const productAvailable = productDetail.totalInventory > 0;
                    const discontinued = productDetail?.discontinued?.value === "true";
        
                    if (productAvailable && !discontinued) {
                        const images = productDetail.images.edges.map(edge => edge.node);
                        const primaryImagesrc = images[0]?.src || '';
                        const secondaryImagesrc = images[1]?.src || '';
        
                        await processProductDetails(
                            productDetail,
                            keyArray,
                            valArray,
                            settings.featured_image_id,
                            document.getElementById("swatch_section_" + productId),
                            productId,
                            primaryImagesrc,
                            secondaryImagesrc,
                            settings.custom_handle,
                            uniqueColors,
                            counter,
                            productAvailable
                        );
                        if (counter.count >= 6) break;
                    }
                }
        
                const swatchSection = document.getElementById("swatch_section_" + productId);
                if (swatchSection) {
                    swatchSection.parentNode.parentNode.parentNode.enableSwatches();
                }
            }
        
            try {
                await handleProductCardHover();
                await collectionSwatchImages();
            } catch (error) {
                console.error('Error handling swatch images or hover events:', error);
            }
        };
    
        setTimeout(async () => {
            try {
                await handleCustomSwatches();
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.warn('Handle custom swatches was aborted');
                } else {
                    console.error('Error handling custom swatches:', error);
                }
            }
        }, 700);
    };

    const collectionSwatchImages = async () => {
        const productCards = document.querySelectorAll('#product-grid product-card.product-card');
        productCards.forEach((productCard) => {
            const collImage = productCard.querySelector('.product-featured-image span.product-coll-images');
            if(collImage){
                const primaryImage = collImage.getAttribute('data-primary');
                const secondaryImage = collImage.getAttribute('data-secondary');
                const prodActiveSwatch = productCard.querySelector('.product-card-info .product-card-swatch .product-card-swatches .product-card-swatch.active');
                if(prodActiveSwatch){
                    prodActiveSwatch.setAttribute('data-srcset', primaryImage);
                    prodActiveSwatch.setAttribute('data-srcset-2', secondaryImage);
                    const prodSecondary = productCard.querySelector('.product-secondary-image');
                    if(prodSecondary){
                        prodSecondary.setAttribute('data-srcset', secondaryImage);
                    }
                }
            }
        });
    };
  
    const hideSpinner = async() => {
        const spinners = document.querySelectorAll('figure.product-featured-image');
        spinners.forEach(spinner => {
            setTimeout(() => {
                spinner.classList.remove('spin_overlay');
            }, 500);
        });
    };

    const facetReset = async () => {
        const resetButtons = document.querySelectorAll('.facets .thb-filter-dropdown__footer .facets__reset');
        const filterParams = { ...queryParams.filter };
        resetButtons.forEach(button => {
            button.addEventListener('click', (event)=>{
                event.preventDefault();
                const facet = button.parentNode.parentNode.parentNode;
                facet.removeAttribute('open');
                let facetType = facet.dataset.type;
                if( facetType != 'ss_color_group'){
                  facetType = `variant_${facetType}`;  
                }
                const checkboxes = facet.querySelectorAll('.thb-filter-dropdown__inner input[type=checkbox]');
                checkboxes.forEach(checkbox => {
                    checkbox.checked = false;
                });
                const facetCounter = facet.querySelector(".thb-filter-dropdown__footer span.facets__selected");
                if (facetCounter) {
                    facetCounter.textContent = `0 selected`;
                }
                delete filterParams[facetType];
                sessionStorage.setItem('natoriFilters', JSON.stringify(filterParams));
            
                queryParams.filter = filterParams;
                queryParams.page = 1;
            
                fetchProductsAndFilters(queryParams);
            });
        });
    };

    const priceRangeSlider = async () => {
        const rangeFilterContainers = document.querySelectorAll('.thb-filter:has(.price_range)');

        function calculateDynamicPriceGap(minRange, maxRange) {
            const totalRange = maxRange - minRange;
            let dynamicGap = Math.max(5, Math.min(100, totalRange * 0.1)); 
            return Math.round(dynamicGap / 5) * 5;
        }
        
        rangeFilterContainers.forEach((container) => {
            const rangeInputs = container.querySelectorAll(".price_range .natori-range-input input"),
                priceInputs = container.querySelectorAll(".price_range .natori-price-input input"),
                range = container.querySelector(".price_range .slider .progress");

            function updateSliderProgress() {
                let minPrice = parseInt(priceInputs[0].value);
                let maxPrice = parseInt(priceInputs[1].value);
                let minRange = parseInt(rangeInputs[0].min);
                let maxRange = parseInt(rangeInputs[0].max);
                let priceGap = calculateDynamicPriceGap(minRange, maxRange);
    
                if (maxPrice - minPrice >= priceGap && maxPrice <= maxRange) {
                    const effectiveRange = maxRange - minRange;
                    range.style.left = ((minPrice - minRange) / effectiveRange) * 100 + "%";
                    range.style.right = 100 - ((maxPrice - minRange) / effectiveRange) * 100 + "%";
                }
            }
    
            updateSliderProgress();
    
            const debouncedUpdateFilter = debounce(() => applyRangeFilter(container), 1500);
    
            priceInputs.forEach((input) => {
                input.addEventListener("input", (e) => {
                    let minPrice = parseInt(priceInputs[0].value),
                        maxPrice = parseInt(priceInputs[1].value);
                    let minRange = parseInt(rangeInputs[0].min);
                    let maxRange = parseInt(rangeInputs[0].max);
                    let priceGap = calculateDynamicPriceGap(minRange, maxRange);
        
                    if (maxPrice - minPrice >= priceGap && maxPrice <= maxRange) {
                        if (e.target.classList.contains("input-min")) {
                            rangeInputs[0].value = minPrice;
                        } else {
                            rangeInputs[1].value = maxPrice;
                        }
                        const effectiveRange = maxRange - minRange;
                        range.style.left = ((minPrice - minRange) / effectiveRange) * 100 + "%";
                        range.style.right = 100 - ((maxPrice - minRange) / effectiveRange) * 100 + "%";
                    }
                    debouncedUpdateFilter();
                });
            });
    
            rangeInputs.forEach((input) => {
                input.addEventListener("input", (e) => {
                    let minVal = parseInt(rangeInputs[0].value),
                        maxVal = parseInt(rangeInputs[1].value);
                    let minRange = parseInt(rangeInputs[0].min);
                    let maxRange = parseInt(rangeInputs[0].max);
                    let priceGap = calculateDynamicPriceGap(minRange, maxRange);
    
                    if (maxVal - minVal < priceGap) {
                        if (e.target.classList.contains("range-min")) {
                            rangeInputs[0].value = maxVal - priceGap;
                        } else {
                            rangeInputs[1].value = minVal + priceGap;
                        }
                    } else {
                        priceInputs[0].value = minVal;
                        priceInputs[1].value = maxVal;
                        const effectiveRange = maxRange - minRange;
                        range.style.left = ((minVal - minRange) / effectiveRange) * 100 + "%";
                        range.style.right = 100 - ((maxVal - minRange) / effectiveRange) * 100 + "%";
                    }
                    debouncedUpdateFilter();
                });
            });
        });
    };

    const applyRangeFilter = async (container) => {
        document.querySelectorAll('.facets__form details.thb-filter').forEach((detailElement) => {
            detailElement.removeAttribute('open');
        });
        const filterSidebar = document.querySelector('facetfiltersformmobile .facet-drawer.side-panel');
        if (filterSidebar) {
            filterSidebar.classList.remove('active');
        }
        const body = document.querySelector('body');
        if (body) {
            body.classList.remove('open-cc');
        }
        const priceMin = container.querySelector('.range-min').value;
        const priceMax = container.querySelector('.range-max').value;

        const variantPrice = {
            low: priceMin, 
            high: priceMax
        };
    
        const variantPriceKey = 'variant_price';
        const filterParams = { ...queryParams.filter };
        filterParams[variantPriceKey] = variantPrice;
        
        let storedFilters = JSON.parse(sessionStorage.getItem('natoriFilters') || '{}');
        const updatedFilters = { ...storedFilters, ...filterParams };
        sessionStorage.setItem('natoriFilters', JSON.stringify(updatedFilters));
        queryParams.filter = filterParams;
        queryParams.page = 1;
    
        fetchProductsAndFilters(queryParams);
    };
    
    await updateQueryParams(queryParams);
    await removeAllFilters();
    await FacetsToggle();
    // Initial fetch on page load
    fetchProductsAndFilters(queryParams);
});
